import { makeStyles } from '@material-ui/core/styles';

export const useTicketContainerStyles = makeStyles(() => ({
  container: {
    marginTop: '44px',
    height: 'auto',
  },
  messageContainer: {
    marginBottom: 20,
  },
  ticketListContainer: {
    '& > div:last-child': {
      marginBottom: 10,
    },
  },
}));

export const useTicketDetailStyles = makeStyles(() => ({
  ticketDetailContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: (props) =>
      props.mobile ? '0.4fr 1fr' : '0.4fr 1fr 1fr',
    columnGap: 50,
  },
  skeleton: {
    width: (props) => (props.mobile ? 108 : 173),
    height: (props) => (props.mobile ? 108 : 173),
  },
  image: {
    width: (props) => (props.mobile ? 108 : 173),
    height: (props) => (props.mobile ? 108 : 173),
    objectFit: 'cover',
  },
  titleEmptyState: {
    fontWeight: 600,
    marginBottom: 10,
  },
  text: {
    fontSize: 16,
  },
}));
